
// // import React, { useEffect, useRef, useState } from 'react';
// // import { useParams, useSearchParams, useNavigate } from 'react-router-dom';
// // import {
// //   MeetingHeader,
// //   MeetingControls,
// //   ScreenGrid,
// //   ParticipantList,
// //   LoadingMeeting,
// //   MeetingOnboarding,
// // } from '@/components/meeting';
// // import { useMeeting, useRealtimeKit, useScreenShare } from '@/hooks';
// // import { Button } from '@/components/ui';
// // import { AlertCircle, HelpCircle } from 'lucide-react';
// // import { useNetworkStatus } from '@/hooks/useNetworkStatus';
// // import { useOnboarding } from '@/components/meeting/MeetingOnboarding';
// // import { useMeetingTimer } from '@/hooks/useMeetingTimer';
// // import { MeetingTimerDisplay } from '@/components/meeting/MeetingTimerDisplay';
// // import { UpgradeModal } from '@/components/meeting/UpgradeModal';
// // import { apiClient } from '@/services/api';

// // export const Meeting: React.FC = () => {
// //   const { id: meetingId } = useParams<{ id: string }>();
// //   const [searchParams] = useSearchParams();
// //   const navigate = useNavigate();
// //   const participantName = searchParams.get('name') || 'Guest';
// //   const [showUpgradeModal, setShowUpgradeModal] = useState(false);
// // const [upgradeModalForParticipants, setUpgradeModalForParticipants] = useState(false);


// //   // Track if we've already joined to prevent double-joining
// //   const hasJoinedRef = useRef(false);
// //   const isLeavingRef = useRef(false);
// // const { start: startOnboarding } = useOnboarding();
// //   // Backend meeting state management
// //   const {
// //     meeting,
// //     participants,
// //     activeScreenShares,
// //     currentParticipant,
// //     authToken,
// //     realtimeKitMeetingId: _realtimeKitMeetingId,
// //     isLoading: isMeetingLoading,
// //     error: meetingError,
// //     joinMeeting,
// //     leaveMeeting: leaveBackendMeeting,
// //     endMeeting,
// //     toggleScreenShare: toggleScreenShareBackend,
// //     isHost,
// //     canScreenShare,
// //     participantCount,
// //   } = useMeeting({
// //     meetingId: meetingId || '',
// //     participantName,
// //     onMeetingEnded: () => {
// //       if (!isLeavingRef.current) {
// //         alert('Meeting has ended');
// //         navigate('/');
// //       }
// //     },
// //     onParticipantJoined: (participant) => {
// //       console.log('Participant joined:', participant.name);
// //     },
// //     onParticipantLeft: (participantId) => {
// //       console.log('Participant left:', participantId);
// //     },
// //     onScreenShareStarted: (share) => {
// //       console.log('Screen share started:', share);
// //     },
// //     onScreenShareStopped: (participantId) => {
// //       console.log('Screen share stopped:', participantId);
// //     },
// //   });

// //   const {
// //     meeting: rtkMeeting,
// //     audioLevels,
// //     connectionQuality,
// //     isInitialized,
// //     isJoined,
// //     error: rtkError,
// //     isAudioEnabled,
// //     isVideoEnabled,
// //     isScreenSharing,
// //     toggleAudio,
// //     toggleVideo,
// //     toggleScreenShare: toggleScreenShareRtk,
// //     leaveMeeting: leaveRtkMeeting,
// //     screenShareTracks,
// //     getScreenShareTrack,
// //   } = useRealtimeKit({
// //     authToken,
// //     onMeetingJoined: () => {
// //       console.log('Connected to RealtimeKit');
// //     },
// //     onMeetingLeft: () => {
// //       console.log('Disconnected from RealtimeKit');
// //     },
// //     onScreenShareUpdate: (participantId, enabled) => {
// //       console.log(`Screen share ${enabled ? 'started' : 'stopped'}:`, participantId);
// //     },
// //   });

// //   const { isOnline, connectionSpeed } = useNetworkStatus();

// //   // Screen share slot management (4 concurrent max)
// //   const {
// //     screenSlots: _screenSlots,
// //     activeScreens,
// //     availableSlots: _availableSlots,
// //     isAtCapacity,
// //     isCurrentUserSharing,
// //     canStartScreenShare,
// //     stats,
// //   } = useScreenShare({
// //     activeScreenShares,
// //     participants,
// //     currentParticipantId: currentParticipant?.id || null,
// //   });

// //   const {
// //   timeRemaining,
// //   formattedTime,
// //   isInGracePeriod,
// //   isExpired,
// //   progress,
// // } = useMeetingTimer({
// //   startedAt: meeting?.startedAt,
// //   tier: meeting?.tier || 'free',
// //   isHost,
// //   onTimeWarning: (minutesRemaining) => {
// //     console.log(`⏰ Time warning: ${minutesRemaining} minutes remaining`);
// //     if (isHost) {
// //       // Show a notification
// //       alert(`${minutesRemaining} minutes remaining! Upgrade to continue.`);
// //     }
// //   },
// //   onGracePeriodStart: () => {
// //     console.log('🚨 Grace period started');
// //     if (isHost) {
// //       setShowUpgradeModal(true);
// //     } else {
// //       setUpgradeModalForParticipants(true);
// //     }
// //   },
// //   onTimeExpired: () => {
// //     console.log('⏱️ Time expired');
// //     alert('Meeting time has expired');
// //     navigate('/');
// //   },
// // });

// //   // ALL useEffect hooks BEFORE any early returns
// //   useEffect(() => {
// //     if (participants.length === 2) {
// //       console.log('=== Participant Information ===');
// //       console.log('Participant 1:', {
// //         id: participants[0].id,
// //         name: participants[0].name,
// //         isHost: participants[0].permissions.isHost,
// //       });
// //       console.log('Participant 2:', {
// //         id: participants[1].id,
// //         name: participants[1].name,
// //         isHost: participants[1].permissions.isHost,
// //       });
// //       console.log('Your ID:', currentParticipant?.id);
// //     }
// //   }, [participants, currentParticipant]);

// //   // Auto-join backend meeting on mount
// //   useEffect(() => {
// //     if (!hasJoinedRef.current && meetingId) {
// //       hasJoinedRef.current = true;
// //       joinMeeting().catch((error) => {
// //         console.error('Failed to join meeting:', error);
// //         hasJoinedRef.current = false;
// //       });
// //     }
// //   }, [joinMeeting, meetingId]);

// //   // Debug screen share state
// //   useEffect(() => {
// //     console.log('=== Screen Share Debug ===');
// //     console.log('Backend activeScreenShares:', activeScreenShares);
// //     console.log('RTK screenShareTracks:', Array.from(screenShareTracks.entries()));
// //     console.log('RTK isScreenSharing:', isScreenSharing);
// //     console.log('Current participant:', currentParticipant?.id);
// //     console.log('Active screens:', activeScreens);
// //   }, [activeScreenShares, screenShareTracks, isScreenSharing, currentParticipant, activeScreens]);



// //   // Handle WebSocket events for upgrades
// // useEffect(() => {
// //   // Listen for meeting state updates (tier changes)
// //   const handleMeetingStateUpdate = (event: any) => {
// //     if (event.type === 'meeting-state' && event.data?.tier) {
// //       console.log('Meeting upgraded to:', event.data.tier);
// //       setShowUpgradeModal(false);
// //       setUpgradeModalForParticipants(false);
// //       // Refresh meeting info to get new tier

// //     }
// //   };

// //   // Add listener when WebSocket is connected
// //   // (You'll need to expose this in useMeeting or handle in the hook)
// // }, []);

// // // Upgrade handler for host
// // const handleUpgrade = async (tier: 'pro' | 'enterprise') => {
// //   if (!currentParticipant) {
// //     throw new Error('Not joined to meeting');
// //   }

// //   try {
// //     console.log(`Upgrading meeting to ${tier}...`);

// //     const response = await apiClient.upgradeMeeting(
// //       meetingId || '',
// //       currentParticipant.id,
// //       tier
// //     );

// //     console.log('Upgrade successful:', response);

// //     // Refresh meeting info


// //     setShowUpgradeModal(false);
// //   } catch (error) {
// //     console.error('Upgrade failed:', error);
// //     throw error;
// //   }
// // };

// // // Enforce screen share limits based on tier
// // const handleToggleScreenShareWithLimits = async () => {
// //   const tier = meeting?.tier || 'free';
// //   const limits = {
// //     free: 2,
// //     pro: 4,
// //     enterprise: 8,
// //   };

// //   const maxScreenShares = limits[tier];

// //   if (!isCurrentUserSharing && activeScreenShares.length >= maxScreenShares) {
// //     alert(`Maximum ${maxScreenShares} screens reached for ${tier} tier. ${tier === 'free' ? 'Upgrade to Pro for more!' : ''}`);

// //     if (tier === 'free' && isHost) {
// //       setShowUpgradeModal(true);
// //     }
// //     return;
// //   }

// //   // Call your existing toggle function
// //   await handleToggleScreenShare();
// // };


// //   // Handle leaving with proper cleanup order
// //   const handleLeaveMeeting = async () => {
// //     if (isLeavingRef.current) return;

// //     if (confirm('Are you sure you want to leave the meeting?')) {
// //       isLeavingRef.current = true;

// //       try {
// //         await leaveRtkMeeting();
// //         await leaveBackendMeeting();
// //         navigate('/');
// //       } catch (error) {
// //         console.error('Error leaving meeting:', error);
// //         isLeavingRef.current = false;
// //         navigate('/');
// //       }
// //     }
// //   };

// //   // Handle ending (host only)
// //   const handleEndMeeting = async () => {
// //     if (isLeavingRef.current) return;

// //     if (confirm('Are you sure you want to end the meeting for everyone?')) {
// //       isLeavingRef.current = true;

// //       try {
// //         await endMeeting();
// //         await leaveRtkMeeting();
// //         navigate('/');
// //       } catch (error) {
// //         console.error('Failed to end meeting:', error);
// //         alert('Failed to end meeting');
// //         isLeavingRef.current = false;
// //       }
// //     }
// //   };

// //   // Handle screen share toggle with proper error handling
// //   const handleToggleScreenShare = async () => {
// //     try {
// //       if (isCurrentUserSharing) {
// //         await toggleScreenShareRtk();
// //         await toggleScreenShareBackend('stop');
// //       } else {
// //         if (!canStartScreenShare) {
// //           alert(`Maximum ${stats.total} screens reached. Please wait for a slot to open.`);
// //           return;
// //         }

// //         await toggleScreenShareRtk();
// //         await toggleScreenShareBackend('start');
// //       }
// //     } catch (error) {
// //       console.error('Screen share toggle failed:', error);

// //       if (isScreenSharing) {
// //         try {
// //           await toggleScreenShareRtk();
// //         } catch (cleanupError) {
// //           console.error('Failed to cleanup screen share:', cleanupError);
// //         }
// //       }

// //       alert('Failed to toggle screen share. Please try again.');
// //     }
// //   };


// // const backendToRtkIdMap = new Map<string, string>();

// // if (rtkMeeting?.self) {
// //   // Map self
// //   const backendSelf = participants.find(p => p.name === rtkMeeting.self.name);
// //   if (backendSelf) {
// //     backendToRtkIdMap.set(backendSelf.id, rtkMeeting.self.id);
// //   }
// // }

// // // Map other participants
// // if (rtkMeeting?.participants?.joined) {
// //   Array.from(rtkMeeting.participants.joined.values()).forEach((rtkP: any) => {
// //     const backendP = participants.find(p => p.name === rtkP.name);
// //     if (backendP) {
// //       backendToRtkIdMap.set(backendP.id, rtkP.id);
// //     }
// //   });
// // }
// // useEffect(() => {
// //   console.log('=== AUDIO DEBUG ===');
// //   console.log('Current user (should be non-host):', currentParticipant?.id);
// //   console.log('Backend participants:', participants.map(p => ({ 
// //     id: p.id, 
// //     name: p.name, 
// //     isHost: p.permissions.isHost 
// //   })));
// //   console.log('ID Mapping:', Array.from(backendToRtkIdMap.entries()));

// //   if (rtkMeeting?.participants?.joined) {
// //     console.log('RTK Participants with audio:', 
// //       Array.from(rtkMeeting.participants.joined.values()).map((p: any) => ({
// //         id: p.id,
// //         name: p.name,
// //         audioEnabled: p.audioEnabled,
// //         hasAudioTrack: !!p.audioTrack,
// //         audioTrackState: p.audioTrack?.readyState
// //       }))
// //     );
// //   }
// // }, [participants, backendToRtkIdMap, rtkMeeting, currentParticipant]);

// // console.log('ID Mapping:', Array.from(backendToRtkIdMap.entries()));
// // const screensForGrid = activeScreens.map(screen => {
// //   const rtkParticipantId = backendToRtkIdMap.get(screen.participantId);

// //   let track: MediaStreamTrack | undefined;

// //   if (rtkParticipantId) {
// //     // Get from the stored tracks Map using RTK ID
// //     track = screenShareTracks.get(rtkParticipantId) || undefined;
// //   }

// //   console.log(`Getting track for backend:${screen.participantId} -> rtk:${rtkParticipantId}:`, {
// //     hasTrack: !!track,
// //     trackId: track?.id,
// //   });

// //   return {
// //     id: screen.participantId,
// //     participantName: screen.participant?.name || 'Unknown User',
// //     isScreenShare: true,
// //     track: track,
// //   };
// // });

// //   // NOW all early returns come AFTER all hooks
// //   if (!meetingId) {
// //     return (
// //       <div className="flex items-center justify-center h-screen">
// //         <div className="text-center">
// //           <AlertCircle className="mx-auto text-red-500 mb-4" size={48} />
// //           <h2 className="text-xl font-bold mb-2">Invalid Meeting ID</h2>
// //           <Button onClick={() => navigate('/')}>Go Home</Button>
// //         </div>
// //       </div>
// //     );
// //   }

// //   // Loading state
// //   if (isMeetingLoading) {
// //     return <LoadingMeeting message="Joining meeting..." />;
// //   }

// //   // Error state
// //   if (meetingError || rtkError) {
// //     return (
// //       <div className="flex items-center justify-center h-screen">
// //         <div className="text-center max-w-md">
// //           <AlertCircle className="mx-auto text-red-500 mb-4" size={48} />
// //           <h2 className="text-xl font-bold mb-2">Connection Error</h2>
// //           <p className="text-gray-600 mb-4">{meetingError || rtkError}</p>
// //           <div className="flex gap-2 justify-center">
// //             <Button onClick={() => window.location.reload()}>Retry</Button>
// //             <Button variant="outline" onClick={() => navigate('/')}>
// //               Go Home
// //             </Button>
// //           </div>
// //         </div>
// //       </div>
// //     );
// //   }

// //   // Not connected to RealtimeKit yet
// //   if (!isInitialized || !isJoined) {
// //     return <LoadingMeeting message="Connecting to meeting infrastructure..." />;
// //   }

// //   // Network status checks
// //   if (!isOnline) {
// //     return <LoadingMeeting message="No internet connection. Please check your network." />;
// //   }

// //   // Add this function with your other handlers (after handleToggleScreenShare)
// // const handleMuteParticipant = async (participantId: string) => {
// //   try {
// //     // Get the RTK participant ID from the backend ID
// //     const rtkId = backendToRtkIdMap.get(participantId);

// //     if (!rtkId || !rtkMeeting?.participants?.joined) {
// //       console.error('Could not find participant to mute');
// //       return;
// //     }

// //     const participant = rtkMeeting.participants.joined.get(rtkId);

// //     if (!participant) {
// //       console.error('Participant not found in RTK meeting');
// //       return;
// //     }

// //     // Only hosts can mute others
// //     if (!isHost) {
// //       console.error('Only hosts can mute participants');
// //       return;
// //     }

// //     // Disable the participant's audio
// //     // Note: The exact API method depends on RealtimeKit's implementation
// //     // You might need to check the RealtimeKit docs for the correct method
// //     await participant.disableAudio();

// //     console.log('Muted participant:', participant.name);
// //   } catch (error) {
// //     console.error('Failed to mute participant:', error);
// //     alert('Failed to mute participant. Please try again.');
// //   }
// // };

// //   return (


// //   <div className="flex flex-col h-screen bg-neutral-950">
// //     {/* Onboarding */}
// //     <MeetingOnboarding 
// //       autoStart={true}
// //       onComplete={() => console.log('Onboarding completed!')}
// //     />

// //     {/* Network Warning Banner */}
// //     {connectionSpeed === 'slow' && (
// //       <div className="bg-yellow-900/50 border-b border-yellow-700/50 p-2">
// //         <p className="text-sm text-yellow-200 text-center">
// //           Slow network detected. Video quality may be affected.
// //         </p>
// //       </div>
// //     )}

// //     {/* Header */}
// //     <MeetingHeader
// //       meetingTitle={meeting?.title || 'Meeting Room'}
// //       meetingId={meetingId || ''}
// //       participantCount={participantCount}
// //     />
// //      {/* Add timer display */}
// //   <MeetingTimerDisplay
// //     timeRemaining={timeRemaining}
// //     formattedTime={formattedTime}
// //     isInGracePeriod={isInGracePeriod}
// //     tier={meeting?.tier || 'free'}
// //     progress={progress}
// //   />

// //     {/* Main Content - Mobile Optimized */}
// //     <div className="flex-1 flex flex-col lg:flex-row overflow-hidden">
// //       {/* Video Grid - Takes full width on mobile */}
// //       <div data-tour="screen-grid" className="flex-1 p-3 sm:p-4 overflow-hidden pb-24 md:pb-4">
// //         {activeScreens.length > 0 ? (
// //           <ScreenGrid screens={screensForGrid} maxScreens={4} />
// //         ) : (
// //           <div className="flex items-center justify-center h-full">
// //             <div className="text-center px-4">
// //               <p className="text-neutral-400 mb-2">No screens being shared</p>
// //               <p className="text-sm text-neutral-500">
// //                 {canScreenShare
// //                   ? 'Click the screen share button to start'
// //                   : 'Waiting for someone to share their screen'}
// //               </p>
// //             </div>
// //           </div>
// //         )}

// //         {/* Screen share status */}
// //         {stats.occupied > 0 && (
// //           <div className="mt-4 p-3 bg-primary-500/10 border border-primary-500/20 rounded-lg">
// //             <p className="text-sm text-primary-300">
// //               {stats.occupied} / {stats.total} screens active
// //               {stats.available > 0 && ` • ${stats.available} slot${stats.available > 1 ? 's' : ''} available`}
// //             </p>
// //           </div>
// //         )}

// //         {isAtCapacity && !isCurrentUserSharing && (
// //           <div className="mt-4 p-3 bg-yellow-900/20 border border-yellow-700/30 rounded-lg">
// //             <p className="text-sm text-yellow-200">
// //               Maximum {stats.total} screens reached. Wait for a slot to open.
// //             </p>
// //           </div>
// //         )}
// //       </div>

// //       {/* Sidebar - Hidden on mobile, visible on desktop */}
// //       <div data-tour="participants" className="hidden lg:block w-80 p-4 bg-neutral-900 border-l border-white/10 overflow-y-auto">
// //         {/* <ParticipantList
// //           participants={participants}
// //           currentUserId={currentParticipant?.id || ''}
// //           rtkMeeting={rtkMeeting}
// //           backendToRtkIdMap={backendToRtkIdMap}
// //           audioLevels={audioLevels}
// //           connectionQuality={connectionQuality}
// //         /> */}
// //         <ParticipantList
// //   participants={participants}
// //   currentUserId={currentParticipant?.id || ''}
// //   rtkMeeting={rtkMeeting}
// //   backendToRtkIdMap={backendToRtkIdMap}
// //   audioLevels={audioLevels}
// //   connectionQuality={connectionQuality}
// //   isHost={isHost} // ADD THIS LINE
// //   onMuteParticipant={handleMuteParticipant} // ADD THIS LINE
// // />

// //         {/* Stats Card */}
// //         <div className="mt-4 p-3 bg-white/5 rounded-lg border border-white/10">
// //           <p className="text-xs text-neutral-400 mb-2">Screen Shares</p>
// //           <p className="text-sm font-medium text-white">
// //             {stats.occupied} / {stats.total} active
// //           </p>
// //           {stats.available > 0 && (
// //             <p className="text-xs text-accent-400 mt-1">
// //               {stats.available} slot{stats.available > 1 ? 's' : ''} available
// //             </p>
// //           )}
// //         </div>

// //         {/* Connection Status */}
// //         <div className="mt-4 p-3 bg-white/5 rounded-lg border border-white/10">
// //           <p className="text-xs text-neutral-400 mb-2">Connection</p>
// //           <div className="flex items-center gap-2">
// //             <div className={`w-2 h-2 rounded-full ${isJoined ? 'bg-accent-400' : 'bg-neutral-600'}`} />
// //             <p className="text-sm text-white">{isJoined ? 'Connected' : 'Disconnected'}</p>
// //           </div>
// //         </div>

// //         {/* Help Button */}
// //         <button 
// //           onClick={() => startOnboarding()}
// //           className="mt-4 w-full p-3 bg-white/5 hover:bg-white/10 rounded-lg border border-white/10 flex items-center transition-all"
// //         >
// //           <HelpCircle className="text-neutral-400 mr-2" size={18} />
// //           <p className="text-sm text-neutral-300">View Onboarding</p>
// //         </button>
// //       </div>
// //     </div>

// //     <UpgradeModal
// //   isOpen={showUpgradeModal || upgradeModalForParticipants}
// //   onClose={() => {
// //     setShowUpgradeModal(false);
// //     setUpgradeModalForParticipants(false);
// //   }}
// //   onUpgrade={handleUpgrade}
// //   isHost={isHost}
// //   currentTier={meeting?.tier || 'free'}
// //   timeRemaining={timeRemaining}
// //   isInGracePeriod={isInGracePeriod}
// // />


// //     {/* Controls */}
// //     <MeetingControls
// //       isAudioEnabled={isAudioEnabled}
// //       isVideoEnabled={isVideoEnabled}
// //       isScreenSharing={isCurrentUserSharing}
// //       canScreenShare={canScreenShare && !isAtCapacity}
// //       onToggleAudio={toggleAudio}
// //       onToggleVideo={toggleVideo}
// //       onToggleScreenShare={handleToggleScreenShareWithLimits}
// //       onLeaveMeeting={handleLeaveMeeting}
// //       onEndMeeting={isHost ? handleEndMeeting : undefined}
// //     />
// //   </div>
// //   );
// // };


// // src/pages/Meeting.tsx - COMPLETE VERSION

// import React, { useEffect, useRef, useState } from 'react';
// import { useParams, useSearchParams, useNavigate } from 'react-router-dom';
// import { Users, X, AlertCircle, HelpCircle } from 'lucide-react';
// import {
//   MeetingHeader,
//   MeetingControls,
//   ScreenGrid,
//   ParticipantList,
//   LoadingMeeting,
//   MeetingOnboarding,
// } from '@/components/meeting';
// import { useMeeting, useRealtimeKit, useScreenShare } from '@/hooks';
// import { useMeetingTimer } from '@/hooks/useMeetingTimer';
// import { UpgradeModal } from '@/components/meeting/UpgradeModal';
// import { Button } from '@/components/ui';
// import { useNetworkStatus } from '@/hooks/useNetworkStatus';
// import { useOnboarding } from '@/components/meeting/MeetingOnboarding';
// import { apiClient } from '@/services/api';
// import { TimerBadge } from '@/components/meeting/TimerBadge';

// export const Meeting: React.FC = () => {
//   const { id: meetingId } = useParams<{ id: string }>();
//   const [searchParams] = useSearchParams();
//   const navigate = useNavigate();
//   const participantName = searchParams.get('name') || 'Guest';

//   // ========== STATE ==========
//   const [showUpgradeModal, setShowUpgradeModal] = useState(false);
//  // const [upgradeModalForParticipants, setUpgradeModalForParticipants] = useState(false);
//   const [showMobileParticipants, setShowMobileParticipants] = useState(false); // NEW: Mobile sidebar

//   const hasJoinedRef = useRef(false);
//   const isLeavingRef = useRef(false);
//   const { start: startOnboarding } = useOnboarding();

//   // ========== HOOKS ==========
//   const {
//     meeting,
//     participants,
//     activeScreenShares,
//     currentParticipant,
//     authToken,
//     isLoading: isMeetingLoading,
//     error: meetingError,
//     joinMeeting,
//     leaveMeeting: leaveBackendMeeting,
//     endMeeting,
//     toggleScreenShare: toggleScreenShareBackend,
//     refreshMeetingInfo,
//     isHost,
//     canScreenShare,
//     participantCount,
//   } = useMeeting({
//     meetingId: meetingId || '',
//     participantName,
//     onMeetingEnded: () => {
//       if (!isLeavingRef.current) {
//         alert('Meeting has ended');
//         navigate('/');
//       }
//     },
//     onParticipantJoined: (participant) => console.log('Joined:', participant.name),
//     onParticipantLeft: (participantId) => console.log('Left:', participantId),
//     onScreenShareStarted: (share) => console.log('Screen share started:', share),
//     onScreenShareStopped: (participantId) => console.log('Screen share stopped:', participantId),
//   });

//   const {
//     meeting: rtkMeeting,
//     audioLevels,
//     connectionQuality,
//     isInitialized,
//     isJoined,
//     error: rtkError,
//     isAudioEnabled,
//     isVideoEnabled,
//     isScreenSharing,
//     toggleAudio,
//     toggleVideo,
//     toggleScreenShare: toggleScreenShareRtk,
//     leaveMeeting: leaveRtkMeeting,
//     screenShareTracks,
//   } = useRealtimeKit({
//     authToken,
//     onMeetingJoined: () => console.log('RTK connected'),
//     onMeetingLeft: () => console.log('RTK disconnected'),
//     onScreenShareUpdate: (participantId, enabled) => {
//       console.log(`Screen share ${enabled ? 'started' : 'stopped'}:`, participantId);
//     },
//   });

//   const { isOnline, connectionSpeed } = useNetworkStatus();

//   const {
//     activeScreens,
//     isAtCapacity,
//     isCurrentUserSharing,
//     canStartScreenShare,
//     stats,
//   } = useScreenShare({
//     activeScreenShares,
//     participants,
//     currentParticipantId: currentParticipant?.id || null,
//   });

//   const {
//     timeRemaining,
//     formattedTime,
//     isInGracePeriod,
//     progress,
//   } = useMeetingTimer({
//     startedAt: meeting?.createdAt,
//     tier: meeting?.tier || 'free',
//     isHost,
//     onTimeWarning: (minutesRemaining) => {
//       console.log(`⏰ ${minutesRemaining} min remaining`);
//       if (isHost) alert(`${minutesRemaining} minutes left! Upgrade to continue.`);
//     },
//     onGracePeriodStart: () => {
//       console.log('🚨 Grace period started');
//       if (isHost) setShowUpgradeModal(true);
//       // else setUpgradeModalForParticipants(true);
//     },
//     onTimeExpired: () => {
//       console.log('⏱️ Expired');
//       alert('Meeting time expired');
//       navigate('/');
//     },
//   });

//   // Right after useMeetingTimer hook
// // useEffect(() => {
// //   console.log('=== TIMER DEBUG ===');
// //   console.log('Meeting data:', meeting);
// //   console.log('Meeting tier:', meeting?.tier);
// //   console.log('Meeting startedAt:', meeting?.startedAt);
// //   console.log('Time remaining:', timeRemaining);
// //   console.log('Formatted time:', formattedTime);
// //   console.log('Is in grace period:', isInGracePeriod);
// //   console.log('Progress:', progress);
// //   console.log('Is host:', isHost);
// // }, [meeting, timeRemaining, formattedTime, isInGracePeriod, progress, isHost]);
//   // ========== ID MAPPING ==========
//   const backendToRtkIdMap = new Map<string, string>();
//   if (rtkMeeting?.self) {
//     const backendSelf = participants?.find(p => p.name === rtkMeeting.self.name);
//     if (backendSelf) backendToRtkIdMap.set(backendSelf.id, rtkMeeting.self.id);
//   }
//   if (rtkMeeting?.participants?.joined) {
//     Array.from(rtkMeeting.participants.joined.values()).forEach((rtkP: any) => {
//       const backendP = participants?.find(p => p.name === rtkP.name);
//       if (backendP) backendToRtkIdMap.set(backendP.id, rtkP.id);
//     });
//   }

//   // ========== EFFECTS ==========
//   useEffect(() => {
//     if (!hasJoinedRef.current && meetingId) {
//       hasJoinedRef.current = true;
//       joinMeeting().catch((error) => {
//         console.error('Failed to join:', error);
//         hasJoinedRef.current = false;
//       });
//     }
//   }, [joinMeeting, meetingId]);

//   // ========== HANDLERS ==========
//   const handleUpgrade = async (tier: 'pro' | 'enterprise') => {
//     if (!currentParticipant) throw new Error('Not joined');
//     try {
//       console.log(`🚀 Upgrading to ${tier}...`);
//       await apiClient.upgradeMeeting(meetingId || '', currentParticipant.id, tier);
//       await refreshMeetingInfo();
//       console.log('✅ Upgraded!');
//       setShowUpgradeModal(false);
//       //setUpgradeModalForParticipants(false);
//     } catch (error) {
//       console.error('❌ Upgrade failed:', error);
//       throw error;
//     }
//   };

//   const handleToggleScreenShareWithLimits = async () => {
//     const tier = meeting?.tier || 'free';
//     const limits = { free: 2, pro: 4, enterprise: 8 };
//     const max = limits[tier];

//     if (!isCurrentUserSharing && activeScreenShares.length >= max) {
//       if (tier === 'free' && isHost) setShowUpgradeModal(true);
//       else alert(`Max ${max} screens for ${tier} tier`);
//       return;
//     }

//     await handleToggleScreenShare();
//   };

//   const handleToggleScreenShare = async () => {
//     try {
//       if (isCurrentUserSharing) {
//         await toggleScreenShareRtk();
//         await toggleScreenShareBackend('stop');
//       } else {
//         if (!canStartScreenShare) {
//           alert(`Max ${stats.total} screens reached`);
//           return;
//         }
//         await toggleScreenShareRtk();
//         await toggleScreenShareBackend('start');
//       }
//     } catch (error) {
//       console.error('Screen share failed:', error);
//       alert('Failed to toggle screen share');
//     }
//   };

//   const handleLeaveMeeting = async () => {
//     if (isLeavingRef.current) return;
//     if (confirm('Leave meeting?')) {
//       isLeavingRef.current = true;
//       try {
//         await leaveRtkMeeting();
//         await leaveBackendMeeting();
//         navigate('/');
//       } catch (error) {
//         console.error('Leave error:', error);
//         navigate('/');
//       }
//     }
//   };

//   const handleEndMeeting = async () => {
//     if (isLeavingRef.current) return;
//     if (confirm('End meeting for everyone?')) {
//       isLeavingRef.current = true;
//       try {
//         await endMeeting();
//         await leaveRtkMeeting();
//         navigate('/');
//       } catch (error) {
//         console.error('End error:', error);
//         alert('Failed to end meeting');
//         isLeavingRef.current = false;
//       }
//     }
//   };

//   const handleMuteParticipant = async (participantId: string) => {
//     try {
//       const rtkId = backendToRtkIdMap.get(participantId);
//       if (!rtkId || !rtkMeeting?.participants?.joined) return;

//       const participant = rtkMeeting.participants.joined.get(rtkId);
//       if (!participant) return;

//       if (!isHost) {
//         console.error('Only hosts can mute');
//         return;
//       }

//       await participant.disableAudio();
//       console.log('Muted:', participant.name);
//     } catch (error) {
//       console.error('Mute failed:', error);
//       alert('Failed to mute participant');
//     }
//   };

//   // ========== SCREEN TRACKS ==========
//   const screensForGrid = activeScreens.map(screen => {
//     const rtkParticipantId = backendToRtkIdMap.get(screen.participantId);
//     const track = rtkParticipantId ? screenShareTracks.get(rtkParticipantId) : undefined;
//     return {
//       id: screen.participantId,
//       participantName: screen.participant?.name || 'Unknown',
//       isScreenShare: true,
//       track: track,
//     };
//   });

//   // ========== EARLY RETURNS ==========
//   if (!meetingId) {
//     return (
//       <div className="flex items-center justify-center h-screen">
//         <div className="text-center">
//           <AlertCircle className="mx-auto text-red-500 mb-4" size={48} />
//           <h2 className="text-xl font-bold mb-2">Invalid Meeting ID</h2>
//           <Button onClick={() => navigate('/')}>Go Home</Button>
//         </div>
//       </div>
//     );
//   }

//   if (isMeetingLoading) return <LoadingMeeting message="Joining meeting..." />;

//   if (meetingError || rtkError) {
//     return (
//       <div className="flex items-center justify-center h-screen">
//         <div className="text-center max-w-md">
//           <AlertCircle className="mx-auto text-red-500 mb-4" size={48} />
//           <h2 className="text-xl font-bold mb-2">Connection Error</h2>
//           <p className="text-gray-600 mb-4">{meetingError || rtkError}</p>
//           <div className="flex gap-2 justify-center">
//             <Button onClick={() => window.location.reload()}>Retry</Button>
//             <Button variant="outline" onClick={() => navigate('/')}>Go Home</Button>
//           </div>
//         </div>
//       </div>
//     );
//   }

//   if (!isInitialized || !isJoined) {
//     return <LoadingMeeting message="Connecting to meeting infrastructure..." />;
//   }

//   if (!isOnline) {
//     return <LoadingMeeting message="No internet connection. Please check your network." />;
//   }

//   // ========== MAIN RENDER ==========
//   return (
//     <div className="flex flex-col h-screen bg-neutral-950">
//       {/* Onboarding */}
//       <div className="hidden lg:block">
//         <MeetingOnboarding 
//           autoStart={true}
//           onComplete={() => console.log('Onboarding completed!')}
//         />
//       </div>
//       {/* Network Warning */}
//       {connectionSpeed === 'slow' && (
//         <div className="bg-yellow-900/50 border-b border-yellow-700/50 p-2">
//           <p className="text-sm text-yellow-200 text-center">
//             Slow network detected. Video quality may be affected.
//           </p>
//         </div>
//       )}

//       {/* Header */}
//       <MeetingHeader
//         meetingTitle={meeting?.title || 'Meeting Room'}
//         meetingId={meetingId || ''}
//         participantCount={participantCount}
//         timeRemaining={timeRemaining}
//         formattedTime={formattedTime}
//         isInGracePeriod={isInGracePeriod}
//         tier={meeting?.tier || 'free'}
//         progress={progress}
//       />

//       {/* Mobile Floating Participant Button */}
//       <button
//         onClick={() => setShowMobileParticipants(true)}
//         className="lg:hidden fixed bottom-32 right-4 z-40 bg-primary-500 hover:bg-primary-600 text-white p-3 rounded-full shadow-lg flex items-center gap-2 transition-all"
//       >
//         <Users size={20} />
//         <span className="text-sm font-medium">{participantCount}</span>
//       </button>

//       {/* Mobile Participant Sidebar Overlay */}
//       {showMobileParticipants && (
//         <div className="lg:hidden fixed inset-0 z-50 flex">
//           {/* Backdrop */}
//           <div 
//             className="flex-1 bg-black/60 backdrop-blur-sm"
//             onClick={() => setShowMobileParticipants(false)}
//           />

//           {/* Sidebar */}
//           <div className="w-80 bg-neutral-900 border-l border-white/10 overflow-y-auto animate-in slide-in-from-right duration-300">
//             {/* Header */}
//             <div className="p-4 border-b border-white/10 flex items-center justify-between sticky top-0 bg-neutral-900 z-10">
//               <h3 className="text-white font-semibold">Participants ({participantCount})</h3>
//               <button
//                 onClick={() => setShowMobileParticipants(false)}
//                 className="p-2 hover:bg-white/10 rounded-lg transition-all"
//               >
//                 <X size={20} className="text-neutral-400" />
//               </button>
//             </div>

//             {/* Participant List */}
//             <div className="p-4">
//               <ParticipantList
//                 participants={participants}
//                 currentUserId={currentParticipant?.id || ''}
//                 rtkMeeting={rtkMeeting}
//                 backendToRtkIdMap={backendToRtkIdMap}
//                 audioLevels={audioLevels}
//                 connectionQuality={connectionQuality}
//                 isHost={isHost}
//                 onMuteParticipant={handleMuteParticipant}
//               />
//             </div>
//           </div>
//         </div>
//       )}

//       {/* Main Content */}
//       <div className="flex-1 flex flex-col lg:flex-row overflow-hidden">
//         {/* Video Grid */}
//         <div data-tour="screen-grid" className="flex-1 p-3 sm:p-4 overflow-hidden pb-24 md:pb-4">
//           {activeScreens.length > 0 ? (
//             <ScreenGrid screens={screensForGrid} maxScreens={4} />
//           ) : (
//             <div className="flex items-center justify-center h-full">
//               <div className="text-center px-4">
//                 <p className="text-neutral-400 mb-2">No screens being shared</p>
//                 <p className="text-sm text-neutral-500">
//                   {canScreenShare
//                     ? 'Click the screen share button to start'
//                     : 'Waiting for someone to share their screen'}
//                 </p>
//               </div>
//             </div>
//           )}

//           {/* Screen Share Status */}
//           {stats.occupied > 0 && (
//             <div className="mt-4 p-3 bg-primary-500/10 border border-primary-500/20 rounded-lg">
//               <p className="text-sm text-primary-300">
//                 {stats.occupied} / {stats.total} screens active
//                 {stats.available > 0 && ` • ${stats.available} slot${stats.available > 1 ? 's' : ''} available`}
//               </p>
//             </div>
//           )}

//           {isAtCapacity && !isCurrentUserSharing && (
//             <div className="mt-4 p-3 bg-yellow-900/20 border border-yellow-700/30 rounded-lg">
//               <p className="text-sm text-yellow-200">
//                 Maximum {stats.total} screens reached. Wait for a slot to open.
//               </p>
//             </div>
//           )}
//         </div>

//         {/* Desktop Sidebar */}
//         <div data-tour="participants" className="hidden lg:block w-80 p-4 bg-neutral-900 border-l border-white/10 overflow-y-auto">
//           <ParticipantList
//             participants={participants}
//             currentUserId={currentParticipant?.id || ''}
//             rtkMeeting={rtkMeeting}
//             backendToRtkIdMap={backendToRtkIdMap}
//             audioLevels={audioLevels}
//             connectionQuality={connectionQuality}
//             isHost={isHost}
//             onMuteParticipant={handleMuteParticipant}
//           />

//           {/* Stats Card */}
//           <div className="mt-4 p-3 bg-white/5 rounded-lg border border-white/10">
//             <p className="text-xs text-neutral-400 mb-2">Screen Shares</p>
//             <p className="text-sm font-medium text-white">
//               {stats.occupied} / {stats.total} active
//             </p>
//             {stats.available > 0 && (
//               <p className="text-xs text-accent-400 mt-1">
//                 {stats.available} slot{stats.available > 1 ? 's' : ''} available
//               </p>
//             )}
//           </div>

//           {/* Connection Status */}
//           <div className="mt-4 p-3 bg-white/5 rounded-lg border border-white/10">
//             <p className="text-xs text-neutral-400 mb-2">Connection</p>
//             <div className="flex items-center gap-2">
//               <div className={`w-2 h-2 rounded-full ${isJoined ? 'bg-accent-400' : 'bg-neutral-600'}`} />
//               <p className="text-sm text-white">{isJoined ? 'Connected' : 'Disconnected'}</p>
//             </div>
//           </div>

//           {/* Help Button */}
//           <button 
//             onClick={() => startOnboarding()}
//             className="mt-4 w-full p-3 bg-white/5 hover:bg-white/10 rounded-lg border border-white/10 flex items-center transition-all"
//           >
//             <HelpCircle className="text-neutral-400 mr-2" size={18} />
//             <p className="text-sm text-neutral-300">View Onboarding</p>
//           </button>
//         </div>
//       </div>

//       {/* Upgrade Modal */}
//       <UpgradeModal
//          isOpen={(isInGracePeriod && meeting?.tier === 'free') || showUpgradeModal}
//         onClose={() => {
//           setShowUpgradeModal(false);
//           //setUpgradeModalForParticipants(false);
//         }}
//         onUpgrade={handleUpgrade}
//         isHost={isHost}
//         currentTier={meeting?.tier || 'free'}
//         timeRemaining={timeRemaining}
//         isInGracePeriod={isInGracePeriod}
//       />

//       {/* Meeting Controls */}
//       <MeetingControls
//         isAudioEnabled={isAudioEnabled}
//         isVideoEnabled={isVideoEnabled}
//         isScreenSharing={isCurrentUserSharing}
//         canScreenShare={canScreenShare && !isAtCapacity}
//         onToggleAudio={toggleAudio}
//         onToggleVideo={toggleVideo}
//         onToggleScreenShare={handleToggleScreenShareWithLimits}
//         onLeaveMeeting={handleLeaveMeeting}
//         onEndMeeting={isHost ? handleEndMeeting : undefined}
//       />
//     </div>
//   );
// };


import React, { useEffect, useRef, useState } from 'react';
import { useParams, useSearchParams, useNavigate } from 'react-router-dom';
import { Users, X, AlertCircle, HelpCircle } from 'lucide-react';
import {
  MeetingHeader,
  MeetingControls,
  ScreenGrid,
  ParticipantList,
  LoadingMeeting,
  MeetingOnboarding,
} from '@/components/meeting';
import { useMeeting, useRealtimeKit, useScreenShare } from '@/hooks';
import { useMeetingTimer } from '@/hooks/useMeetingTimer';
import { UpgradeModal } from '@/components/meeting/UpgradeModal';
import { Button } from '@/components/ui';
import { useNetworkStatus } from '@/hooks/useNetworkStatus';
import { useOnboarding } from '@/components/meeting/MeetingOnboarding';
import { apiClient } from '@/services/api';

export const Meeting: React.FC = () => {
  const { id: meetingId } = useParams<{ id: string }>();
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const participantName = searchParams.get('name') || 'Guest';

  const [showUpgradeModal, setShowUpgradeModal] = useState(false);
  const [showMobileParticipants, setShowMobileParticipants] = useState(false);

  const hasJoinedRef = useRef(false);
  const isLeavingRef = useRef(false);
  const { start: startOnboarding } = useOnboarding();

  const {
    meeting,
    participants,
    activeScreenShares,
    currentParticipant,
    authToken,
    isLoading: isMeetingLoading,
    error: meetingError,
    joinMeeting,
    leaveMeeting: leaveBackendMeeting,
    endMeeting,
    toggleScreenShare: toggleScreenShareBackend,
    refreshMeetingInfo,
    isHost,
    canScreenShare,
    participantCount,
  } = useMeeting({
    meetingId: meetingId || '',
    participantName,
    onMeetingEnded: () => {
      if (!isLeavingRef.current) {
        alert('Meeting has ended');
        navigate('/');
      }
    },
    onParticipantJoined: (participant) => console.log('Joined:', participant.name),
    onParticipantLeft: (participantId) => console.log('Left:', participantId),
    onScreenShareStarted: (share) => console.log('Screen share started:', share),
    onScreenShareStopped: (participantId) => console.log('Screen share stopped:', participantId),
  });

  const {
    meeting: rtkMeeting,
    audioLevels,
    connectionQuality,
    isInitialized,
    isJoined,
    error: rtkError,
    isAudioEnabled,
    isVideoEnabled,
    isScreenSharing,
    toggleAudio,
    toggleVideo,
    toggleScreenShare: toggleScreenShareRtk,
    leaveMeeting: leaveRtkMeeting,
    screenShareTracks,
  } = useRealtimeKit({
    authToken,
    onMeetingJoined: () => console.log('RTK connected'),
    onMeetingLeft: () => console.log('RTK disconnected'),
    // ✅ FIX: ADD THE TWO MISSING FUNCTION PROPS
    onParticipantJoined: (participant) => console.log('RTK Participant Joined:', participant.name),
    onParticipantLeft: (participant) => console.log('RTK Participant Left:', participant.name),
    onScreenShareUpdate: (participantId, enabled) => {
      console.log(`Screen share ${enabled ? 'started' : 'stopped'}:`, participantId);
    },
  });

  const { isOnline, connectionSpeed } = useNetworkStatus();

  const {
    activeScreens,
    isAtCapacity,
    isCurrentUserSharing,
    canStartScreenShare,
    stats,
  } = useScreenShare({
    activeScreenShares,
    participants,
    currentParticipantId: currentParticipant?.id || null,
  });

  const {
    timeRemaining,
    formattedTime,
    isInGracePeriod,
    progress,
  } = useMeetingTimer({
    startedAt: meeting?.createdAt,
    tier: meeting?.tier || 'free',
    isHost,
    onTimeWarning: (minutesRemaining) => {
      console.log(`⏰ ${minutesRemaining} min remaining`);
      if (isHost) alert(`${minutesRemaining} minutes left! Upgrade to continue.`);
    },
    onGracePeriodStart: () => {
      console.log('🚨 Grace period started');
      if (isHost) setShowUpgradeModal(true);
    },
    onTimeExpired: () => {
      console.log('⏱️ Expired');
      alert('Meeting time expired');
      navigate('/');
    },
  });

  const backendToRtkIdMap = new Map<string, string>();
  if (rtkMeeting?.self) {
    const backendSelf = participants?.find(p => p.name === rtkMeeting.self.name);
    if (backendSelf) backendToRtkIdMap.set(backendSelf.id, rtkMeeting.self.id);
  }
  if (rtkMeeting?.participants?.joined) {
    Array.from(rtkMeeting.participants.joined.values()).forEach((rtkP: any) => {
      const backendP = participants?.find(p => p.name === rtkP.name);
      if (backendP) backendToRtkIdMap.set(backendP.id, rtkP.id);
    });
  }

  useEffect(() => {
    if (!hasJoinedRef.current && meetingId) {
      hasJoinedRef.current = true;
      joinMeeting().catch((error) => {
        console.error('Failed to join:', error);
        hasJoinedRef.current = false;
      });
    }
  }, [joinMeeting, meetingId]);

  const handleUpgrade = async (tier: 'pro' | 'enterprise') => {
    if (!currentParticipant) throw new Error('Not joined');
    try {
      console.log(`🚀 Upgrading to ${tier}...`);
      await apiClient.upgradeMeeting(meetingId || '', currentParticipant.id, tier);
      await refreshMeetingInfo();
      console.log('✅ Upgraded!');
      setShowUpgradeModal(false);
    } catch (error) {
      console.error('❌ Upgrade failed:', error);
      throw error;
    }
  };

  const handleToggleScreenShareWithLimits = async () => {
    const tier = meeting?.tier || 'free';
    const limits = { free: 2, pro: 4, enterprise: 8 };
    const max = limits[tier];

    if (!isCurrentUserSharing && activeScreenShares.length >= max) {
      if (tier === 'free' && isHost) setShowUpgradeModal(true);
      else alert(`Max ${max} screens for ${tier} tier`);
      return;
    }

    await handleToggleScreenShare();
  };

  const handleToggleScreenShare = async () => {
    try {
      if (isCurrentUserSharing) {
        await toggleScreenShareRtk();
        await toggleScreenShareBackend('stop');
      } else {
        if (!canStartScreenShare) {
          alert(`Max ${stats.total} screens reached`);
          return;
        }
        await toggleScreenShareRtk();
        await toggleScreenShareBackend('start');
      }
    } catch (error) {
      console.error('Screen share failed:', error);
      alert('Failed to toggle screen share');
    }
  };

  const handleLeaveMeeting = async () => {
    if (isLeavingRef.current) return;
    if (confirm('Leave meeting?')) {
      isLeavingRef.current = true;
      try {
        await leaveRtkMeeting();
        await leaveBackendMeeting();
        navigate('/');
      } catch (error) {
        console.error('Leave error:', error);
        navigate('/');
      }
    }
  };

  const handleEndMeeting = async () => {
    if (isLeavingRef.current) return;
    if (confirm('End meeting for everyone?')) {
      isLeavingRef.current = true;
      try {
        await endMeeting();
        await leaveRtkMeeting();
        navigate('/');
      } catch (error) {
        console.error('End error:', error);
        alert('Failed to end meeting');
        isLeavingRef.current = false;
      }
    }
  };

  const handleMuteParticipant = async (participantId: string) => {
    try {
      const rtkId = backendToRtkIdMap.get(participantId);
      if (!rtkId || !rtkMeeting?.participants?.joined) return;

      const participant = rtkMeeting.participants.joined.get(rtkId);
      if (!participant) return;

      if (!isHost) {
        console.error('Only hosts can mute');
        return;
      }

      await participant.disableAudio();
      console.log('Muted:', participant.name);
    } catch (error) {
      console.error('Mute failed:', error);
      alert('Failed to mute participant');
    }
  };

  const screensForGrid = activeScreens.map(screen => {
    const rtkParticipantId = backendToRtkIdMap.get(screen.participantId);
    const track = rtkParticipantId ? screenShareTracks.get(rtkParticipantId) : undefined;
    return {
      id: screen.participantId,
      participantName: screen.participant?.name || 'Unknown',
      isScreenShare: true,
      track: track,
    };
  });

  if (!meetingId) {
    return (
      <div className="flex items-center justify-center h-screen">
        <div className="text-center">
          <AlertCircle className="mx-auto text-red-500 mb-4" size={48} />
          <h2 className="text-xl font-bold mb-2">Invalid Meeting ID</h2>
          <Button onClick={() => navigate('/')}>Go Home</Button>
        </div>
      </div>
    );
  }

  if (isMeetingLoading) return <LoadingMeeting message="Joining meeting..." />;

  if (meetingError || rtkError) {
    return (
      <div className="flex items-center justify-center h-screen">
        <div className="text-center max-w-md">
          <AlertCircle className="mx-auto text-red-500 mb-4" size={48} />
          <h2 className="text-xl font-bold mb-2">Connection Error</h2>
          <p className="text-gray-600 mb-4">{meetingError || rtkError}</p>
          <div className="flex gap-2 justify-center">
            <Button onClick={() => window.location.reload()}>Retry</Button>
            <Button variant="outline" onClick={() => navigate('/')}>Go Home</Button>
          </div>
        </div>
      </div>
    );
  }

  if (!isInitialized || !isJoined) {
    return <LoadingMeeting message="Connecting to meeting infrastructure..." />;
  }

  if (!isOnline) {
    return <LoadingMeeting message="No internet connection. Please check your network." />;
  }

  return (
    <div className="flex flex-col h-screen bg-neutral-950">
      <div className="hidden lg:block">
        <MeetingOnboarding
          autoStart={true}
          onComplete={() => console.log('Onboarding completed!')}
        />
      </div>

      {connectionSpeed === 'slow' && (
        <div className="bg-yellow-900/50 border-b border-yellow-700/50 p-2">
          <p className="text-sm text-yellow-200 text-center">
            Slow network detected. Video quality may be affected.
          </p>
        </div>
      )}

      <MeetingHeader
        meetingTitle={meeting?.title || 'Meeting Room'}
        meetingId={meetingId || ''}
        participantCount={participantCount}
        timeRemaining={timeRemaining}
        formattedTime={formattedTime}
        isInGracePeriod={isInGracePeriod}
        tier={meeting?.tier || 'free'}
        progress={progress}
      />

      <button
        onClick={() => setShowMobileParticipants(true)}
        className="lg:hidden fixed bottom-32 right-4 z-40 bg-primary-500 hover:bg-primary-600 text-white p-3 rounded-full shadow-lg flex items-center gap-2 transition-all"
      >
        <Users size={20} />
        <span className="text-sm font-medium">{participantCount}</span>
      </button>

      {showMobileParticipants && (
        <div className="lg:hidden fixed inset-0 z-50 flex">
          <div
            className="flex-1 bg-black/60 backdrop-blur-sm"
            onClick={() => setShowMobileParticipants(false)}
          />

          <div className="w-80 bg-neutral-900 border-l border-white/10 overflow-y-auto animate-in slide-in-from-right duration-300">
            <div className="p-4 border-b border-white/10 flex items-center justify-between sticky top-0 bg-neutral-900 z-10">
              <h3 className="text-white font-semibold">Participants ({participantCount})</h3>
              <button
                onClick={() => setShowMobileParticipants(false)}
                className="p-2 hover:bg-white/10 rounded-lg transition-all"
              >
                <X size={20} className="text-neutral-400" />
              </button>
            </div>

            <div className="p-4">
              <ParticipantList
                participants={participants}
                currentUserId={currentParticipant?.id || ''}
                rtkMeeting={rtkMeeting}
                backendToRtkIdMap={backendToRtkIdMap}
                audioLevels={audioLevels}
                connectionQuality={connectionQuality}
                isHost={isHost}
                onMuteParticipant={handleMuteParticipant}
              />
            </div>
          </div>
        </div>
      )}

      {/* <div className="flex-1 flex flex-col lg:flex-row overflow-hidden">
        <div className="flex-1 p-3 sm:p-4 overflow-hidden pb-24 md:pb-4">
          <div data-tour="screen-grid" className="h-full w-full">
            {activeScreens.length > 0 ? (
              <ScreenGrid screens={screensForGrid} maxScreens={4} />
            ) : (
              <div className="flex items-center justify-center h-full">
                <div className="text-center px-4">
                  <p className="text-neutral-400 mb-2">No screens being shared</p>
                  <p className="text-sm text-neutral-500">
                    {canScreenShare
                      ? 'Click the screen share button to start'
                      : 'Waiting for someone to share their screen'}
                  </p>
                </div>
              </div>
            )}
          </div>
        </div>

        <div data-tour="participants" className="hidden lg:block w-80 p-4 bg-neutral-900 border-l border-white/10 overflow-y-auto">
          <ParticipantList
            participants={participants}
            currentUserId={currentParticipant?.id || ''}
            rtkMeeting={rtkMeeting}
            backendToRtkIdMap={backendToRtkIdMap}
            audioLevels={audioLevels}
            connectionQuality={connectionQuality}
            isHost={isHost}
            onMuteParticipant={handleMuteParticipant}
          />

          <div className="mt-4 p-3 bg-white/5 rounded-lg border border-white/10">
            <p className="text-xs text-neutral-400 mb-2">Screen Shares</p>
            <p className="text-sm font-medium text-white">
              {stats.occupied} / {stats.total} active
            </p>
            {stats.available > 0 && (
              <p className="text-xs text-accent-400 mt-1">
                {stats.available} slot{stats.available > 1 ? 's' : ''} available
              </p>
            )}
          </div>

          <div className="mt-4 p-3 bg-white/5 rounded-lg border border-white/10">
            <p className="text-xs text-neutral-400 mb-2">Connection</p>
            <div className="flex items-center gap-2">
              <div className={`w-2 h-2 rounded-full ${isJoined ? 'bg-accent-400' : 'bg-neutral-600'}`} />
              <p className="text-sm text-white">{isJoined ? 'Connected' : 'Disconnected'}</p>
            </div>
          </div>

          <button
            onClick={() => startOnboarding()}
            className="mt-4 w-full p-3 bg-white/5 hover:bg-white/10 rounded-lg border border-white/10 flex items-center transition-all"
          >
            <HelpCircle className="text-neutral-400 mr-2" size={18} />
            <p className="text-sm text-neutral-300">View Onboarding</p>
          </button>
        </div>
      </div> */}
      <div className="flex-1 flex flex-col lg:flex-row overflow-hidden">
        {/* Dynamic Main Area - Shows ParticipantList OR ScreenGrid */}
        <div className={`transition-all duration-500 ease-in-out overflow-hidden pb-24 md:pb-4 ${activeScreens.length > 0
          ? 'flex-1 p-3 sm:p-4' // Normal size when screen sharing
          : 'flex-1 p-3 sm:p-4' // Takes full width when no screen share
          }`}>
          <div data-tour="screen-grid" className="h-full w-full">
            {activeScreens.length > 0 ? (
              // Screen sharing active - show ScreenGrid
              <ScreenGrid screens={screensForGrid} maxScreens={4} />
            ) : (
              // No screen sharing - show ParticipantList in grid mode
              <ParticipantList
                participants={participants}
                currentUserId={currentParticipant?.id || ''}
                rtkMeeting={rtkMeeting}
                backendToRtkIdMap={backendToRtkIdMap}
                audioLevels={audioLevels}
                connectionQuality={connectionQuality}
                isHost={isHost}
                onMuteParticipant={handleMuteParticipant}
                viewMode="grid" // New prop to tell it to render as grid
              />
            )}
          </div>
        </div>

        {/* Sidebar - Only shows when screen sharing */}
        <div
          data-tour="participants"
          className={`hidden lg:block w-80 p-4 bg-neutral-900 border-l border-white/10 overflow-y-auto transition-all duration-500 ease-in-out ${activeScreens.length > 0
            ? 'translate-x-0 opacity-100' // Slide in when screen sharing
            : 'translate-x-full opacity-0 pointer-events-none' // Hide when no screen share
            }`}
        >
          <ParticipantList
            participants={participants}
            currentUserId={currentParticipant?.id || ''}
            rtkMeeting={rtkMeeting}
            backendToRtkIdMap={backendToRtkIdMap}
            audioLevels={audioLevels}
            connectionQuality={connectionQuality}
            isHost={isHost}
            onMuteParticipant={handleMuteParticipant}
            viewMode="list" // Sidebar list mode
          />

          <div className="mt-4 p-3 bg-white/5 rounded-lg border border-white/10">
            <p className="text-xs text-neutral-400 mb-2">Screen Shares</p>
            <p className="text-sm font-medium text-white">
              {stats.occupied} / {stats.total} active
            </p>
            {stats.available > 0 && (
              <p className="text-xs text-accent-400 mt-1">
                {stats.available} slot{stats.available > 1 ? 's' : ''} available
              </p>
            )}
          </div>

          <div className="mt-4 p-3 bg-white/5 rounded-lg border border-white/10">
            <p className="text-xs text-neutral-400 mb-2">Connection</p>
            <div className="flex items-center gap-2">
              <div className={`w-2 h-2 rounded-full ${isJoined ? 'bg-accent-400' : 'bg-neutral-600'}`} />
              <p className="text-sm text-white">{isJoined ? 'Connected' : 'Disconnected'}</p>
            </div>
          </div>

          <button
            onClick={() => startOnboarding()}
            className="mt-4 w-full p-3 bg-white/5 hover:bg-white/10 rounded-lg border border-white/10 flex items-center transition-all"
          >
            <HelpCircle className="text-neutral-400 mr-2" size={18} />
            <p className="text-sm text-neutral-300">View Onboarding</p>
          </button>
        </div>
      </div>

      <UpgradeModal
        isOpen={(isInGracePeriod && meeting?.tier === 'free') || showUpgradeModal}
        onClose={() => {
          setShowUpgradeModal(false);
        }}
        onUpgrade={handleUpgrade}
        isHost={isHost}
        currentTier={meeting?.tier || 'free'}
        timeRemaining={timeRemaining}
        isInGracePeriod={isInGracePeriod}
      />

      <MeetingControls
        isAudioEnabled={isAudioEnabled}
        isVideoEnabled={isVideoEnabled}
        isScreenSharing={isCurrentUserSharing}
        canScreenShare={canScreenShare && !isAtCapacity}
        onToggleAudio={toggleAudio}
        onToggleVideo={toggleVideo}
        onToggleScreenShare={handleToggleScreenShareWithLimits}
        onLeaveMeeting={handleLeaveMeeting}
        onEndMeeting={isHost ? handleEndMeeting : undefined}
      />
    </div>


  );
};